import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ViewChild, AfterViewInit, Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { SuperAdminProxyService } from 'src/app/shared/services/super-admin-proxy.service';

@Component({
  selector: 'app-organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.css']
})
export class OrganizationComponent implements OnInit, AfterViewInit {

  searchKeyword = "";
  displayedColumns: string[] = ['srNo', 'org_name', 'org_type', 'onboarding_date','branch', 'status', 'action'];//
  userData: any = [];
  roleName:any;
  /** Super Admin sees "Organization list" as page title */
  isSuperAdmin = false;
  /** JWT type === 1 only — can enter org proxy mode */
  canProxyAsOrganization = false;
  dataSource = new MatTableDataSource<any>([]);
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  permissions: any;
  constructor(
    private readonly apiService: ApiService,
    private router: Router,
    private toastrMsgService: ToastrService,
    private readonly superAdminProxy: SuperAdminProxyService
  ) {

  }

  ngOnInit(): void {
    try {
      const raw = localStorage.getItem('user');
      if (raw) {
        const userParse = JSON.parse(raw);
        const u = userParse?.user || userParse;
        this.roleName = u?.role_name;
        this.isSuperAdmin =
          u?.type === 1 ||
          u?.role_id === 1 ||
          u?.role_name === 'Admin' ||
          u?.role_name === 'Super Admin';
        // Must match server: only JWT type 1 can proxy (user object may omit `type`)
        this.canProxyAsOrganization = this.superAdminProxy.canUseOrgProxy();
      }
    } catch {
      this.isSuperAdmin = false;
      this.canProxyAsOrganization = false;
    }

    this.fetchOrganizations();
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }

  filterByStatus(status: any) {
    this.dataSource.filterPredicate = (data, filter) =>
      !filter || data.kycStatus.toLowerCase() === filter;
    this.dataSource.filter = status.toLowerCase();
  }

  getStatusClass(status: string) {
    switch (status) {
      case 'Verified': return 'bg-green-500 text-white px-2 rounded-full';
      case 'Rejected': return 'bg-red-500 text-white px-2 rounded-full';
      case 'Pending': return 'bg-yellow-400 text-white px-2 rounded-full';
      default: return 'bg-gray-300 text-black px-2 rounded-full';
    }
  }




  fetchOrganizations() {
    const params = { keyword: this.searchKeyword ? this.searchKeyword : "" };
    this.apiService.getOrganizations(params).subscribe({
      next: (res: any) => {
        console.log(res);
        this.dataSource.data = res?.data;
      },
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err.error.message);
      },
      complete: () => console.log('Observable complete'),
    });
  }
  /** Super Admin: API requests impersonate this organization until Exit proxy */
  enterProxy(element: { org_id: number; org_name?: string }): void {
    this.superAdminProxy.setProxy(element.org_id, element.org_name || '');
    this.toastrMsgService.success(
      `Opening portal as ${element.org_name || 'this organization'}…`
    );
    window.location.href = '/home/dashboard';
  }

  deleteOrganization(orgId: number) {
    const confirmDelete = confirm("Are you sure you want to delete this organization?");
    if (!confirmDelete) {
      return;
    }
    this.apiService.deleteOrganization(orgId).subscribe({
      next: (res: any) => {
        console.log(res);
        this.toastrMsgService.success('Organization deleted successfully');
        this.fetchOrganizations();
      },
      error: (err) => {
        console.log(err);
        this.toastrMsgService.error(err.error.errorMessage);
      },
      complete: () => console.log('Observable complete'),
    });
  }

  // fb(){
  //   "cooperative": "Cooperative (Co-op)",
  // "corporation": "Corporation",
  // "franchise": "Franchise",
  // "government_organization": "Government Organization",
  // "joint_venture": "Joint Venture",
  // "opc": "One Person Company (OPC)",
  // "partnership": "Partnership",
  // "private_limited": "Private Limited Company (Pvt Ltd)",
  // "psu": "Public Sector Undertaking (PSU)",
  // "public_limited": "Public Limited Company (Ltd)",
  // "sole_proprietorship": "Sole Proprietorship",
  // "trust": "Trust"
  // }
}